<template>
	<div id="draggable">
		<Modal v-model="isShow" footer-hide :width="750">
			<div slot="header"><b>加入已有箱子</b></div>
			<div style="padding: 20px;" v-if="canJoinBoxList.length">
				<Button type="primary" :ghost="selectIds.includes(item.box_id)?false:true" v-for="(item,index) of canJoinBoxList"
				        :key="index" size="large" style="margin-right: 10px;margin-top:10px;" @click="selectBoxCallback(item)">
					{{item.box_no_title}}
				</Button>
			</div>
			<div style="padding: 20px;text-align: center" v-else>
				暂无可加入的箱子
			</div>
			<br/>
			<div style="color: #e13d13;padding: 0 0 20px 20px">
				<span>若商品已经加入所选箱子将不会重复加入</span>
			</div>
			<div>
				<Button size="large" icon="md-close" style="width: 48%;" @click="isShow=false">取消</Button>
				<Button size="large" icon="md-checkmark-circle" style="width: 50%;" type="primary" @click="doJoinPackingBox"
				        :disabled="!selectIds.length" :loading="buttonLoading">
					<span v-if="selectIds.length">确认</span>
					<span v-else>请选择要加入的箱号</span>
				</Button>
			</div>
		</Modal>

		<!-- 如果碰到滑动问题，1.1 请检查这里是否属于同一点。 -->
		<!-- 悬浮的HTML -->
		<div class="parentWeightCard" ref="moveDiv" @mousedown="down" @touchstart="down" @mousemove="move"
		     @touchmove.prevent="move" @mouseup="end" @touchend="end">
			<div class="weightCardLeft">
				<div style="font-size: 20px;color: #4c70db;margin: 8px;text-align: center;">
					已选:{{selectDatas.length}}
				</div>
			</div>
			<div style="width: 100px;">
				<Button class="joinBoxCardRight1" id="joinBoxCardRight" type="primary" @click="handleClick" v-drag
				        :loading="buttonLoading">
					装箱
				</Button>
				<Button class="joinBoxCardRight2" v-drag :disabled="!this.selectDatas.length" @click="queryCanJoinBoxList">
					加入已有箱
				</Button>
			</div>
		</div>
	</div>
</template>

<script>
	import {doPackingBoxByPackIds, queryCanJoinBoxList, doJoinBox} from "@/api/sorting/packingBox";

	export default {
		name: "joinBox",
		props: {
			// 已选分拣数据
			selectDatas: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				buttonLoading: false,
				// 展示可加入箱子窗口
				isShow: false,
				// 已有箱子列表
				canJoinBoxList: [],
				// 已选择数据
				selectIds: [],
				flags: false,
				position: {x: 0, y: 0}, // 鼠标的横纵坐标
				pageX: "", // 页面可视区域的宽
				pagey: "", // 页面可视区域的高
				nx: "",
				ny: "",
				dx: "",
				dy: "",
				xPum: "",
				yPum: "",
			};
		},
		directives: {
			drag(el) {
				const oDiv = el;
				// 拖拽时间标识
				let firstTime = "";
				let lastTime = "";
				document.onselectstart = function () {
					return false
				};
				oDiv.onmousedown = function (e) {
					// 为了区分点击还是拖拽，使用时间差来判断，200毫秒内为点击，200毫秒外为拖拽，初始化为点击
					document.getElementById('joinBoxCardRight').setAttribute('drag-flag', false);
					firstTime = new Date().getTime();

					// oDiv.offsetParent.offsetWidth - oDiv.offsetLeft - oDiv.offsetWidth
					// 表示元素距离父元素右边距的距离
					const disX = oDiv.offsetParent.offsetWidth - oDiv.offsetLeft - oDiv.offsetWidth + e.clientX;
					// oDiv.offsetTop 表示距离父元素顶边距的距离
					const disY = oDiv.offsetTop - e.clientY;
					// 设置最大右边距
					const maxRight = oDiv.offsetParent.offsetWidth - oDiv.offsetWidth;
					// 设置最大顶边距
					const maxTop = oDiv.offsetParent.offsetHeight - oDiv.offsetHeight;
					document.onmousemove = function (e) {
						// 计算当前右边距并设置
						const r = Math.min(maxRight, Math.max(disX - e.clientX, 0));
						oDiv.style.right = r + 'px';
						// 计算当前顶边距并设置
						const t = Math.min(maxTop, Math.max(disY + e.clientY, 0));
						oDiv.style.top = t + 'px';

						// 判断下当前时间与初始时间差，大于100毫秒则判断状态为拖拽
						lastTime = new Date().getTime();
						if (lastTime - firstTime > 100) {
							document.getElementById('joinBoxCardRight').setAttribute('drag-flag', true);
						}
					};
					// 鼠标抬起时清除事件
					document.onmouseup = function (e) {
						document.onmousemove = null;
						document.onmouseup = null;
					};
					return false;
				}
			}
		},
		methods: {
			// 返回数据
			submitWeightData() {
				this.$emit('reciveData', {data: this.weightNumber});
			},
			// 点击事件
			handleClick() {
				// 点击事件触发时，判断当前状态是拖拽还是点击，若是拖拽，直接返回不继续执行
				const isDrag = document.getElementById('joinBoxCardRight').getAttribute('drag-flag');
				if (isDrag === 'true') return;
				if (!this.selectDatas.length) {
					return this.$Message.warning("请先选择装箱商品！");
				}
				let packIds = [];
				for (let i = 0; i < this.selectDatas.length; i++) {
					packIds.push(this.selectDatas[i].id);
				}
				this.buttonLoading = true;
				doPackingBoxByPackIds({packIds}).then(data => {
					if (data.data.code === 1200) {
						this.$emit("submitJoinBox", {packIds});
					}
					this.buttonLoading = false;
				}).catch(err => {
					this.buttonLoading = false;
					this.$Message.error(err);
				});
			},
			// 查询可加入箱子
			queryCanJoinBoxList() {
				let packIds = [];
				for (let i = 0; i < this.selectDatas.length; i++) {
					packIds.push(this.selectDatas[i].id);
				}
				this.selectIds = [];
				queryCanJoinBoxList({packIds, orderId: this.selectDatas[0].order_id}).then(data => {
					if (data.data.code === 1200) {
						this.isShow = true;
						this.canJoinBoxList = data.data.data;
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},
			// 选择箱子回调
			selectBoxCallback(item) {
				if (this.selectIds.includes(item.box_id)) {
					this.selectIds.splice(this.selectIds.indexOf(item.box_id), 1);
				} else {
					this.selectIds.push(item.box_id);
				}
			},
			// 查询可加入箱子
			doJoinPackingBox() {
				let packIds = [];
				for (let i = 0; i < this.selectDatas.length; i++) {
					packIds.push(this.selectDatas[i].id);
				}
				this.buttonLoading = true;
				doJoinBox({packIds, boxIds: this.selectIds, orderId: this.selectDatas[0].order_id}).then(data => {
					if (data.data.code === 1200) {
						this.isShow = false;
						this.$emit("submitJoinBox", {packIds});
					}
					this.buttonLoading = false;
				}).catch(err => {
					this.buttonLoading = false;
					this.$Message.error(err);
				});
			},
			// 实现移动端拖拽
			down() {
				this.flags = true; //是否开启拖拽
				let touch;
				if (event.touches) {
					touch = event.touches[0];
				} else {
					touch = event;
				}
				this.position.x = touch.clientX;
				this.position.y = touch.clientY;
				this.dx = this.$refs.moveDiv.offsetLeft;
				this.dy = this.$refs.moveDiv.offsetTop;
			},
			move() {
				if (this.flags) {
					let touch;
					if (event.touches) {
						touch = event.touches[0];
					} else {
						touch = event;
					}
					this.nx = touch.clientX - this.position.x;
					this.ny = touch.clientY - this.position.y;

					this.yPum = this.dy + this.ny;
					if (this.dx + this.nx <= 0) {
						this.xPum = 0;
					} else if (this.dx + this.nx >= this.pageX - 260) {
						this.xPum = this.pageX - 260;
					} else {
						this.xPum = this.dx + this.nx;
					}
					if (this.dy + this.ny <= 0) {
						this.yPum = 0;
					} else if (this.dy + this.ny >= this.pagey - 100) {
						this.yPum = this.pagey - 100;
					} else {
						this.yPum = this.dy + this.ny;
					}
					this.$refs.moveDiv.style.left = this.xPum + "px";
					this.$refs.moveDiv.style.top = this.yPum + "px";
					//阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
					document.addEventListener("touchmove",
						function () {
							event.preventDefault();
						},
						false
					);
				}
			},
			//鼠标释放时候的函数
			end() {
				this.flags = false;
			},
		},
		mounted() {
			this.pageX = document.body.offsetWidth;
			this.pagey = document.body.offsetHeight;
		},
		destroyed() {
		},
	}
</script>

<style scoped>
	.parentWeightCard {
		/* 如果页面报错 [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive. See <URL>；   请添加样式 touch-action: none; */
		touch-action: none;
		height: 100px;
		width: 260px;
		/* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
		z-index: 999;
		position: fixed;
		bottom: 10px;
		right: 10px;
		display: flex;
		cursor: pointer;
	}

	.weightCardLeft {
		height: 50px;
		width: 120px;
		border: 1px solid #4c70db;
		background-color: #fff;
	}

	.joinBoxCardRight1 {
		height: 50px;
		width: 140px;
		border-radius: 0;
	}

	.joinBoxCardRight2 {
		height: 50px;
		width: 140px;
		border-radius: 0;
		color: #4c70db;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/boxManage/joinBox.vue